import { appendTerminalChunk } from "./terminal-lines";
import type { ChatContentBlock } from "./chat-types";

/** Reduction is data ownership. Theme renderers never select or replace it. */
export interface ChatBlockKind<K extends ChatContentBlock["type"]> {
  readonly type: K;
  appendDelta(block: Extract<ChatContentBlock, { type: K }>, delta: string): void;
}

export class ChatBlockReducers {
  private reducers = new Map<string, (block: ChatContentBlock, delta: string) => void>();

  constructor() {
    this.register({ type: "text", appendDelta: (block, delta) => { block.text += delta; } });
    this.register({ type: "code", appendDelta: (block, delta) => { block.text += delta; } });
    this.register({ type: "tool_call", appendDelta: (block, delta) => { block.output = (block.output ?? "") + delta; } });
    this.register({ type: "terminal", appendDelta: (block, delta) => {
      appendTerminalChunk(block.lines, delta);
    } });
  }

  register<K extends ChatContentBlock["type"]>(kind: ChatBlockKind<K>): void {
    if (this.reducers.has(kind.type)) throw new RangeError(`Duplicate chat kind: ${kind.type}`);
    this.reducers.set(kind.type, (block, delta) => kind.appendDelta(block as Extract<ChatContentBlock, { type: K }>, delta));
  }

  appendDelta(block: ChatContentBlock, delta: string): boolean {
    const reduce = this.reducers.get(block.type);
    if (!reduce) return false;
    reduce(block, delta);
    return true;
  }
}
